const UPDATE_SETTING_OPTIONS = 'gameState/UPDATE_SETTING_OPTIONS';

export const defaultState = {
    settingOptions: {}
};
const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_SETTING_OPTIONS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function updateSettingOptions(data) {
    return {
        type: UPDATE_SETTING_OPTIONS,
        payload: {
            settingOptions: data
        }
    };
}
